import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const PeriodSelect = ({ value, onChange, opciones, className }) => (
    <Select
        className={className}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="standard"
        disableUnderline
        size="small"
        sx={{
            fontSize: "inherit",
            "& .MuiSelect-select": { paddingTop: 0, paddingBottom: 0, paddingRight: "24px !important" },
        }}
    >
        {opciones.map((o) => (
            <MenuItem key={o.valor} value={o.valor}>{o.etiqueta}</MenuItem>
        ))}
    </Select>
);

export default PeriodSelect;
